<template>
  <div class="loading-logo">
    <div class="logo" style="height: 220px; width: 200px" ref="logoAnimation"></div>
    <div class="title-company">RemotePC</div>
    <div class="title">Vision</div>
  </div>
</template>

<script>

  import lottie from 'lottie-web';

  export default {
    name: "LoadingLogo",

    props: {
      autoplay: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isLoading: false,
        animation: null,
      }
    },

    methods: {
      setLoading(isLoading) {
        this.isLoading = isLoading;
        if (isLoading) {
          this.animation.goToAndPlay(57, true);
        } else {
          this.animation.goToAndStop(57, true)
        }
      },
    },

    mounted() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.logoAnimation,
        animationData: require('../animations/animation_loading'),
        loop: true,
        autoplay: true,
        renderer: 'svg',
      });

      this.$nextTick()
        .then(() => {
          this.setLoading(this.autoplay)
        });
    },

    beforeDestroy() {
      this.animation.destroy()
    }
  }
</script>

<style lang="scss">
  @import "LoadingLogo";
</style>
